import { Entry } from 'contensis-delivery-api';
import HTMLReactParser from 'html-react-parser';

import cmsParser from 'Common/util/cmsParser';

import type { SearchResultCardProps } from 'Components/Card/SearchResult';

const defaultMap = (item: Entry, tag: string, uriDomain?: string): SearchResultCardProps => ({
    heading: item.pageMetadata?.customTitle || item.title,
    description:
        typeof item.description === 'string'
            ? HTMLReactParser(item.description)
            : item.pageMetadata?.description
            ? item.pageMetadata.description
            : undefined,
    tag: tag,
    link: {
        href: uriDomain + item.sys.uri
    },
    image:
        // Solent courses
        item.courseCardImage
            ? cmsParser.image(item.courseCardImage, `${uriDomain}/cms`)
            : // Maritime courses
            item.pageDataEntry?.heroBanner?.image
            ? cmsParser.image(item.pageDataEntry.heroBanner.image, uriDomain)
            : undefined
});

export default defaultMap;
